import { i18n } from "@lingui/core";
import { createElement } from "react";
import { TransNoContext, type TransProps } from "@lingui/react/server";

/**
 * What the macros compile to, via `runtimeConfigModule` in /lingui.config.ts. Compiled code imports
 * `i18n` and `Trans` from here instead of from `@lingui/*`, so a package that uses the macros (DDS)
 * depends on `@web-monorepo/i18n` and nothing else.
 *
 * Lingui's own runtime `Trans` reads `i18n` from an `I18nProvider` and throws without one. That
 * would put a provider in every root, story and test that renders a translated component. This
 * one reads the same global `i18n` singleton the `t` macro does, so `<Trans>` needs no setup at
 * all. `TransNoContext` is Lingui's pure renderer, with no hooks and no context. As with `t`, a
 * string renders whatever catalog is loaded when it renders: the router awaits each route's
 * catalog first (see ./runtime.ts).
 *
 * Plain `.ts` with `createElement`: this module's job is to export the singleton next to the
 * component, which a `.tsx` file may not do under fast refresh.
 */
export { i18n };

export function Trans(props: TransProps) {
  return createElement(TransNoContext, { ...props, lingui: { i18n } });
}
